/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type SbSharedRefineMenuTypeahead_viewer$ref = any;
export type SbSharedRefineMenuTypeaheadQueryVariables = {
    readonly searchString?: string | null;
    readonly hasQuery: boolean;
    readonly facetName?: string | null;
    readonly uriRef?: string | null;
};
export type SbSharedRefineMenuTypeaheadQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": SbSharedRefineMenuTypeahead_viewer$ref;
    } | null;
};
export type SbSharedRefineMenuTypeaheadQuery = {
    readonly response: SbSharedRefineMenuTypeaheadQueryResponse;
    readonly variables: SbSharedRefineMenuTypeaheadQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "searchString",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasQuery",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "facetName",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "uriRef",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "Variable",
        "name": "facetName",
        "variableName": "facetName"
    } as any), v2 = ({
        "kind": "Variable",
        "name": "searchString",
        "variableName": "searchString"
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "SbSharedRefineMenuTypeaheadQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SbSharedRefineMenuTypeahead_viewer",
                            "args": [
                                (v1 /*: any*/),
                                {
                                    "kind": "Variable",
                                    "name": "hasQuery",
                                    "variableName": "hasQuery"
                                },
                                (v2 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "SbSharedRefineMenuTypeaheadQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasQuery",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "itemFacetSearch",
                                    "storageKey": null,
                                    "args": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 5
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "page",
                                            "value": 1
                                        },
                                        (v2 /*: any*/),
                                        {
                                            "kind": "Variable",
                                            "name": "uriRef",
                                            "variableName": "uriRef"
                                        }
                                    ],
                                    "concreteType": "ItemFacetsQueryConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemFacetsQueryEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "FilterValueType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "urlLabel",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "linkReference",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "displayName",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "count",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "SbSharedRefineMenuTypeaheadQuery",
            "id": "app-buyer-finding/234.0.0-2019-09-27T13:34:34.101Z/SbSharedRefineMenuTypeaheadQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '613f0d2272da29dcbb409c9aa2579468';
export default node;
